import React from 'react';
import * as Card from '../../v2BaseComponents/Card';
import useMedicalProfile from '../../../hooks/api/useMedicalProfile';
import urls from '../../../utils/urls';
import getName from '../../../utils/getName';
import { getAgeString } from '../../../utils/getDateString';
import { getFallbackFromName } from '../../v2BaseComponents/Avatar';

export type ProfileCardOwnProps = {
    profileId: string;
    onPress?: () => void;
    skeletonFallback?: boolean;
};

export type ProfileCardProps = ProfileCardOwnProps;

const ProfileCard: React.FC<ProfileCardProps> = (props) => {
    const { isLoadingProfile, profile } = useMedicalProfile({
        medicalProfileId: props.profileId,
    });

    if (isLoadingProfile || !profile) return props.skeletonFallback ? <Card.CardSkeleton /> : null;

    return (
        <Card.Card onPress={props.onPress}>
            <Card.CardLeftContent
                leftContent={
                    <Card.CardLoadableAvatar
                        size="md"
                        fallbackName={getFallbackFromName(
                            profile.contactDetails.preferredFirstName || profile.contactDetails.firstName,
                            profile.contactDetails.lastName,
                        )}
                        avatarUrl={urls.api.medicalProfiles.avatar(props.profileId)}
                    />
                }
            >
                <Card.CardContent>
                    <Card.CardHeader>{getName(profile.contactDetails)}</Card.CardHeader>
                    {profile.contactDetails.dob ? (
                        <Card.CardBody2>{getAgeString(profile.contactDetails.dob)}</Card.CardBody2>
                    ) : null}
                </Card.CardContent>
            </Card.CardLeftContent>
        </Card.Card>
    );
};

export default React.memo(ProfileCard);
